/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  CreateApplicationInput,
  useCreateApplicationMutation,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  onSuccess: (id: string) => void;
};
export function useCreateApplication({ onSuccess }: Props) {
  const [createApplicationMutation, { loading }] = useCreateApplicationMutation(
    {
      onCompleted: (data) => {
        if (data.createApplication) {
          onSuccess(data?.createApplication.id);
        }
      },
      onError: (error) => {
        showError(
          error.message.toLowerCase() === "conflict"
            ? "Application name must be unique!"
            : error.message
        );
      },
    }
  );

  async function createApplication(data: CreateApplicationInput) {
    await createApplicationMutation({
      variables: {
        input: {
          ...data,
        },
      },
    });
  }

  return {
    createApplication,
    loading,
  };
}
